import React, {useEffect, useRef, useState} from 'react';
import NewYearEvent from "./NewYearEvent";
import {useDispatch, useSelector} from "react-redux";
import {eventsList, getResult, setRef} from "./eventSlice";
import Loader from "../../subsidiary/Loader/Loader";

const NewYearEventPage = () => {
    const showTable = useSelector(state => state.eventSlice.showTable)
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const isEventFinished = useSelector(state => state.eventSlice.events[0]?.isFinish)
    const usersList = useSelector(state => state.eventSlice.events[0]?.users)
    const eventSlice = useSelector(state => state.eventSlice.events[0])
    const ref = useRef(null)
    const [eventFinished, setEventFinished] = useState(isEventFinished)
    const result = useSelector(state => state.eventSlice.results)

    useEffect(() => {
        if (eventSlice && eventSlice.hasOwnProperty('id')) {
            dispatch(getResult({draw_id: eventSlice.id}))
        }
    }, [eventSlice])

    return (
        <div className="content-wrapper">
            <NewYearEvent props={{eventFinished, ref}}/>
            <div className='condition_container'>
                <span className='condition_title'>Результаты</span>
                <p className='condition_first-par'>
                    Дорогие коллеги!
                </p>
                <p className='condition_between-par'>
                    С 19 декабря мы получили от Вас множество прекрасных предновогодних фотографий из разных городов!
                    Среди всех участников мы провели розыгрыш призов.
                    Система автоматически определила кому какой приз достанется, но без подарка не остался никто.
                </p>
                <p className='condition_between-par'>
                    От всей души благодарим всех за участие и публикуем результаты.
                </p>
                <p className='condition_between-par'>
                    Если вы не найдите себя в таблице призов - значит в Ваш адрес будет направлен электронный сертификат
                    Digift.
                </p>
                <p className='condition_between-par'>
                    Все призы будут также разосланы в течение января.
                </p>
            </div>
            <p className='table_main-header' style={eventFinished ? {display: "block"} : {display: 'none'}}>Победители
                новогоднего розыгрыша</p>
            <table ref={ref} className='table' style={eventFinished ? {display: "table"} : {display: "none"}}>
                <tr className='table_header'>
                    <th>№</th>
                    <th>ФИО</th>
                    <th>Приз</th>
                </tr>
                {result?.map(user =>
                    <tr key={user.id} className='table_element'>
                        <td>{user.user_number}</td>
                        <td>{user.name}</td>
                        <td>{user.present}</td>
                    </tr>
                )}
            </table>
        </div>
    );
};

export default NewYearEventPage;